import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector:'terms-conditions',
    templateUrl: '../view/termsConditions.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TermsConditionsComponent {
    
}



// WEBPACK FOOTER //
// D:/a/1/s/src/app/Shared/component/termsConditions.component.ts